import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import styled from 'styled-components';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const GridLogo = styled.img`
  width: 3.5em;
`

const Navigation = () => {
  const [expanded, setExpanded] = useState(false);

  const onSelectItem = () => {
    setExpanded(false);
  }

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      style={{
        "padding": "0.5rem 1rem"
      }}
      sticky="top"
      variant="dark"
    >
      <NavLink
        to="/"
        className="logo"
      >
        <img
          alt="Oracle's Elixir"
          src="/navbar-logo.ico"
          width="44"
          height="44"
        />
      </NavLink>
      <img
        alt='Valorant'
        src='/V_Logomark_Red.png'
        width='64'
        height='64'
        style={{ 'marginLeft': '-1em' }}
      />
      <Navbar.Toggle
        aria-controls="responsive-navbar-nav"
        onClick={
          () => setExpanded(expanded ? false : "expanded")
        }
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <NavLink
            to="/stats"
            onClick={() => onSelectItem()}
          >
            Stats
          </NavLink>
          <NavLink
            to="/player-rankings"
            onClick={() => onSelectItem()}
          >
            Top Players
          </NavLink>
          <NavLink
            to="/players"
            onClick={() => onSelectItem()}
          >
            Player Profiles
          </NavLink>
        </Nav>
      </Navbar.Collapse>
      {/* <GridContainer>
        <Link to='/about'><GridLogo src='/grid_badge.png' /></Link>
      </GridContainer> */}
    </Navbar>
  )
}

export default inject('AppStore')(observer(Navigation));
